import React, { useEffect, useRef } from 'react'
import classNames from 'classnames'
import { Button, Grid, Progress, Tooltip } from 'antd'
import { AiOutlineReload } from 'react-icons/ai'
import i18n from '../../../../lib/i18n'
import antdTheme from '../../../../styles/antdTheme'
import styles from './TopBar.module.scss'

// Title, progress and the question navigator (chips with per-question status)
// showNav: horizontal chips for phones; on wider screens the SideNav column is used instead
function TopBar({ title, questions, results, index, onSelect, onReset, showNav }) {
  const activeRef = useRef(null)
  const showLabels = Grid.useBreakpoint().sm !== false
  const answered = questions.filter(_q => results[_q.id] !== undefined).length
  const correct = questions.filter(_q => results[_q.id] === true).length
  const multiple = questions.length > 1

  useEffect(() => {
    if (activeRef.current) activeRef.current.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' })
  }, [index])

  return (
    <header className={styles.TopBar}>
      <div className={styles.inner}>
        <div className={styles.row}>
          <h1 className={styles.title}>{title || i18n('qv_title')}</h1>
          {multiple && (
            <>
              <span className={styles.score}>
                {i18n('qv_answered')}: <b>{answered}/{questions.length}</b>
                <span className={styles.correctCount}>✓ {correct}</span>
              </span>
              <Tooltip title={i18n('qv_start_over')}>
                <Button
                  icon={<AiOutlineReload size={16} />}
                  aria-label={i18n('qv_start_over')}
                  onClick={onReset}
                  disabled={answered === 0}
                >
                  {showLabels && i18n('qv_start_over')}
                </Button>
              </Tooltip>
            </>
          )}
        </div>

        {multiple && (
          <>
            <Progress
              percent={Math.round((answered / questions.length) * 100)}
              showInfo={false}
              size="small"
              strokeColor={antdTheme.token.colorPrimary}
              className={styles.progress}
            />
            {showNav && <nav className={styles.nav} aria-label={i18n('qv_questions')}>
              {questions.map((question, i) => {
                const result = results[question.id]
                return (
                  <button
                    key={question.id}
                    ref={i === index ? activeRef : null}
                    type="button"
                    aria-current={i === index ? 'step' : undefined}
                    className={classNames(styles.chip, {
                      [styles.active]: i === index,
                      [styles.ok]: result === true,
                      [styles.bad]: result === false,
                    })}
                    onClick={() => onSelect(i)}
                  >
                    {i + 1}
                  </button>
                )
              })}
            </nav>}
          </>
        )}
      </div>
    </header>
  )
}

export default TopBar
